// Shared "Live Occupancy" badge styling + People deep-link helpers so the Fleet card
// and the Live Tracking TelemetryPanel render identical pills and navigation.
//
// Colour scheme (consistent across both pages):
//   Driver    -> emerald
//   Staff     -> blue
//   Passenger -> violet
//   Trailer   -> amber
//   Equipment -> sky
export const OCCUPANCY_BADGE_CLS = {
  driver: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  staff: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  passenger: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
  trailer: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  equipment: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
};

export const PEOPLE_TAB_FOR_TYPE = { driver: 'drivers', staff: 'staff', passenger: 'passengers' };

// Only Driver / Staff / Passenger are people (deep-link to People). Trailer / Equipment are assets.
export const isPersonOccupant = (type) => type === 'driver' || type === 'staff' || type === 'passenger';

export const peopleSearchPath = (personType, name) => {
  const tab = PEOPLE_TAB_FOR_TYPE[personType] || 'drivers';
  const params = new URLSearchParams({ tab, search: name || '' });
  return `/people?${params.toString()}`;
};

// Pagination-proof People deep link — opens the Person Dashboard directly when the
// person id is known (People.jsx open_person consume effect); falls back to the
// tab + search filter otherwise.
export const peopleDeepLinkPath = (personType, personId, name) => {
  if (personId) return `/people?open_person=${personType || 'driver'}:${personId}`;
  return peopleSearchPath(personType, name);
};

// How a binding/driver-session was decided: 'ble' (BLE beacon proximity), 'rfid' (RFID/iButton
// mapped-IO scan) or 'manual' (Manual Driver Allocation default). Reads whichever field the record
// carries — vehicle_bindings use `binding_source` (ble_rssi | mapped_io) and driver_sessions use
// `decision_source` (ble_algorithm | ibutton_rfid | manual_assignment).
export const bindingSourceKind = (source) => {
  const s = String(source || '').toLowerCase();
  if (!s) return null;
  if (s.includes('manual')) return 'manual';
  if (s.includes('ble')) return 'ble';
  if (s.includes('mapped_io') || s.includes('ibutton') || s.includes('rfid') || s.includes('nfc')) return 'rfid';
  return null;
};

export const bindingSourceLabel = (kind) =>
  kind === 'ble' ? 'Bound via BLE beacon' : kind === 'rfid' ? 'Bound via RFID / iButton' : kind === 'manual' ? 'Assigned driver (manual)' : '';

// A Staff sitting in the Driver slot is a driver-eligible Staff acting as the driver.
export const isActingDriverStaff = (rowType, personType) => rowType === 'driver' && personType === 'staff';
